module.exports = __webpack_public_path__ + "img/mkv.993626a3.png";